export const brandName = 'Tov+';

export const publicSiteConfig = {
  brandName,
  marketingSiteUrl: 'https://tovplus.com',
  docsSiteUrl: 'https://docs.tovplus.com',
  plannerAppUrl: 'https://dash.tovplus.com',
  plannerAppSignInUrl: 'https://dash.tovplus.com/signin',
  plannerAppSignUpUrl: 'https://dash.tovplus.com/signup',
  routes: {
    home: '/',
    docs: '/docs',
    signIn: '/signin',
    signUp: '/signup',
    acceptableUse: '/acceptable-use',
    cookiePolicy: '/cookies',
    privacyPolicy: '/privacy',
    termsOfService: '/terms-of-service',
  },
} as const;
